import React, { Component } from 'react';
import './App.css';
import Game from "./containers/Game/Game";

class App extends Component {
  render() {
    return (
        <Game />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js